import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { Advertiser } from '~core/models/advertiser.models';

@Component({
  selector: 'advertiser-details',
  standalone: false,
  templateUrl: './advertiser-details.component.html',
  styleUrl: './advertiser-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvertiserDetailsComponent extends BaseComponent {
  advertisers = input<Advertiser>();
}
